import { render, staticRenderFns } from "./ObjectStoreBadges.vue?vue&type=template&id=233513dc"
import script from "./ObjectStoreBadges.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreBadges.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports